export default "__VITE_ASSET__78305b7d__"